import services from '../createServices';

export const projectAuthority = {
  listForUserGroup: params => services.post('/projectAuthority/listForUserGroup', { params, isLoading: true }),
  listProject: params => services.post('/projectAuthority/listForProject', { params, isLoading: true }),
  saveForUserGroup: params => services.post('/projectAuthority/saveForUserGroup', { params, isLoading: true }),
  saveForProject: params => services.post('/projectAuthority/saveForProject', { params, isLoading: true })
};
